import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { getSupabaseUrl } from '@/lib/urlUtils';

const InviteRedirect = () => {
  const { token } = useParams();

  useEffect(() => {
    if (token) {
      // Redirect to the Supabase invite function
      window.location.href = `${getSupabaseUrl()}/functions/v1/invite/${token}`;
    }
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-lg font-medium mb-2">Redirection en cours...</h1>
        <p className="text-muted-foreground">Veuillez patienter pendant que nous vous redirigeons.</p>
      </div>
    </div>
  );
};

export default InviteRedirect;